import { Element, Editor } from 'slate';
import type { SlateBlock } from '@atlas/renderer';
import convertBlocksToMultiLineTexts from '@atlas/tool/box/slate/convertBlocksToMultiLineTexts';

export default function withRestrictions(editor: Editor, types?: null | TWithRestrictionsValue[]) {
    if (!types || !types.length) return editor;

    const { normalizeNode } = editor;

    editor.normalizeNode = (entry) => {
        const [node, path] = entry;

        if (Element.isElement(node) && node.type !== 'paragraph' && !types.includes(node.type)) {
            convertBlocksToMultiLineTexts(editor, 'paragraph', {
                range: {
                    anchor: Editor.start(editor, path.slice(0, 1)),
                    focus: Editor.end(editor, path.slice(0, 1)),
                },
            });
            // Empty return statement prevents farther normalization in this thread, but previous line will trigger the new one
            return;
        }

        normalizeNode(entry);
    };

    return editor;
}

// #region Types

export type TWithRestrictionsValue = SlateBlock['type'];

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('withRestrictions', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
